import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=214c6dde&scoped=true&"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c6dde",
  null
  
)

export default component.exports